import { render } from "./TestEnd.vue?vue&type=template&id=5b8c91b6&ts=true"
import script from "./TestEnd.vue?vue&type=script&lang=ts"
export * from "./TestEnd.vue?vue&type=script&lang=ts"

import "./TestEnd.vue?vue&type=style&index=0&id=5b8c91b6&lang=stylus"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__